<template>
  <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="?" name="first">
      Placeholder for future tooling
    </el-tab-pane>
  </el-tabs>
</template>

<script>
  import {Tabs, TabPane} from 'element-ui'

  export default {
    components: {
      [Tabs.name]: Tabs,
      [TabPane.name]: TabPane
    },
    data() {
      return {
        activeName: 'first'
      };
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event)
      }
    }
  }
</script>

<style scoped>

</style>
